module.exports = __webpack_public_path__ + "img/backIconLeft2.8c88d58d.png";